<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <action-bar [showSave]="true" (onSave)="clickSave(form?.getRawValue())"></action-bar>
      </div>
    </div>
    <div>
      <div>
        <h3 class="title-margin-top">{{ 'account_section_user' | translate }}</h3>
        <mat-card>
          <div class="row">
            <div class="col-3">
              <mat-form-field>
                <mat-label color="accent">{{ 'account_field_lastname' | translate }}</mat-label>
                <input matInput formControlName="userName" />
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'account_field_firstname' | translate }}</mat-label>
                <input matInput formControlName="userFirstName" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'account_field_email' | translate }}</mat-label>
                <input matInput formControlName="email" />
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label color="accent">{{ 'account_field_login' | translate }}</mat-label>
                <input matInput formControlName="userLogin" />
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label color="accent">{{ 'account_field_status' | translate }}</mat-label>
                <input matInput formControlName="status" />
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>

      <div>
        <div class="title-margin-top edit-password">
          <h3>{{ 'account_section_change_password' | translate }}</h3>
        </div>
        <mat-card>
          <div class="row">
            <div class="col-2">
              <mat-form-field>
                <mat-label>{{ 'reset_password_page_field_password' | translate }}</mat-label>
                <input type="password" matInput formControlName="password" />
              </mat-form-field>
              <mat-error *ngIf="formCrls.password.errors?.pattern">{{ USER_ACCOUNT_CONSTANTS.PasswordPatternErrorMessage }} </mat-error>
            </div>
          </div>
          <div class="row">
            <div class="col-2">
              <mat-form-field>
                <mat-label>{{ 'reset_password_page_field_confirm_password' | translate }}</mat-label>
                <input type="password" matInput formControlName="confirmPassword" />
              </mat-form-field>
              <mat-error *ngIf="formCrls.confirmPassword.errors">{{ 'account_error_password_mismatch' | translate }}</mat-error>
              <mat-error *ngIf="formCrls.confirmPassword.errors?.pattern">{{ USER_ACCOUNT_CONSTANTS.PasswordPatternErrorMessage }} </mat-error>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </form>
</div>
